
import * as React from 'react'
import { SystemGrid, DateCell ,DateTimeCell, SystemPanel} from './../../../library'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import { DownloadFile } from '../../../library/helpers/utils';

export default class ArchiveAuditGrid extends React.Component<any, any, any>{

    DetailComponent = (props: any) => {

        const dataItem = props.dataItem;
        if (dataItem.AuditType != "Delete") return null;

        return (
            <SystemGrid pageSize={100} dataSource={"/Audit/FieldLevelArchive/" + dataItem.ContextId} >
                <Column key={1} field="Key" title="Field Name" cell={(props) => (
                    <td> <strong>{props.dataItem.Key}</strong> </td>)
                } />
                <Column key={2} field="Value" title="Value" />
            </SystemGrid>)
    }

    downloadTemplate = async () => {
    }
    render() {
        return (

            <SystemGrid dataSource={this.props.Schema && this.props.Table &&  "/Audit/GeneralArchive/" + this.props.Schema + '/' + this.props.Table + '/' + this.props.primaryKey} detail={this.DetailComponent} expandField="expanded">
                    <Column key={1} field="AuditType" title="Event Type" />
                    <Column key={2} field="SecurityUserName" title="User" />
                    <Column key={3} field="AuditDateTime" title="Date" cell={DateTimeCell} filter={"date"} />
                </SystemGrid>);
    }
}
//export default AuditGrid